import { Flex } from "antd";
import { FC } from "react";
import { Market, TaskPromoTagPhotos } from "tm-shared/types";

import { SubtaskCard } from "@/components/TasksModals/components/SubtaskCard";
import { useAppSelector } from "@/hooks/redux";

import { CustomTaskFromTaskButton } from "../components/CustomTaskFromTaskButton";
import { TaskViewModal } from "../TaskViewModal";

interface PromoTagPhotosViewModalProps {
    task: TaskPromoTagPhotos;
    market: Market;
    onClose: () => void;
}

export const PromoTagPhotosViewModal: FC<PromoTagPhotosViewModalProps> = ({
    task,
    market,
    onClose,
}) => {
    const { products } = useAppSelector((s) => s.offline);
    const taskPayload = task.payload;
    const completedAt = task?.completedAt;

    if (!taskPayload || !completedAt) return null;

    const subtasks = task.context.products;
    const taskImages = Object.values(taskPayload).flatMap(
        ({ photos }) => photos,
    );

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Flex vertical gap={16}>
                <CustomTaskFromTaskButton
                    task={task}
                    market={market}
                    images={taskImages}
                />
                {subtasks.map(({ barcode }) => {
                    const subtaskPayload = taskPayload[barcode];
                    const title = products?.[barcode]?.name ?? barcode;

                    if (!subtaskPayload) return null;

                    return (
                        <SubtaskCard
                            key={barcode}
                            subtask={subtaskPayload}
                            title={title}
                        />
                    );
                })}
            </Flex>
        </TaskViewModal>
    );
};
